import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import LockIcon from '@material-ui/icons/Lock';
import PublicIcon from '@material-ui/icons/Public';
export const useOnboardPolicyOptions = () => {
  const {
    t
  } = useTranslation();
  const options = useMemo(() => [{
    value: 'free_join',
    label: t('ONBOARD_POLICY.freeJoin.label'),
    description: t('ONBOARD_POLICY.freeJoin.description'),
    icon: PublicIcon
  }, {
    value: 'requires_approval',
    label: t('ONBOARD_POLICY.requiresApproval.label'),
    description: t('ONBOARD_POLICY.requiresApproval.description'),
    icon: CheckBoxIcon
  }, {
    value: 'invite_only',
    label: t('ONBOARD_POLICY.inviteOnly.label'),
    description: t('ONBOARD_POLICY.inviteOnly.description'),
    icon: LockIcon
  }], [t]);
  return options;
};